module.exports = __webpack_public_path__ + "img/book-03_1.216e94e2.png";